// Use this to adjust the mutation to not pass errors to our toast handler.
export const mutationWithoutErrorHandling = {
  mutation: {
    onError: () => null,
  },
};
